module.exports = {
	"config": {
		"siteTitle": "Dominic Tracey",
		"linkPrefix": ""
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "about_me.md",
				"ext": "md",
				"name": "about_me",
				"extname": ".md",
				"basename": "about_me.md",
				"dirname": "",
				"stem": "about_me",
				"path": "about_me.md"
			},
			"requirePath": "about_me.md",
			"path": "/about_me/",
			"data": {
				"title": "About me",
				"subtitle": "Creates great software,<br/> Watches beautiful children grow,<br/> Climbs big rocks,<br/> Dances with pretty girls.<br/>\n",
				"icon": "heart"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "contact.md",
				"ext": "md",
				"name": "contact",
				"extname": ".md",
				"basename": "contact.md",
				"dirname": "",
				"stem": "contact",
				"path": "contact.md"
			},
			"requirePath": "contact.md",
			"path": "/contact/",
			"data": {
				"title": "Contact",
				"subtitle": "You may find me on various social media outlets,<br/>\n Email is the best way to reach me.\n",
				"icon": "phone"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js"
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "intro.md",
				"ext": "md",
				"name": "intro",
				"extname": ".md",
				"basename": "intro.md",
				"dirname": "",
				"stem": "intro",
				"path": "intro.md"
			},
			"requirePath": "intro.md",
			"path": "/intro/",
			"data": {
				"headline": "Dominic Tracey\n",
				"subtitle": "test"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "photos.md",
				"ext": "md",
				"name": "photos",
				"extname": ".md",
				"basename": "photos.md",
				"dirname": "",
				"stem": "photos",
				"path": "photos.md"
			},
			"requirePath": "photos.md",
			"path": "/photos/",
			"data": {
				"title": "Photos",
				"subtitle": "Attempting to portray my life as more interesting than it actually is\n",
				"icon": "camera"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projects",
				"base": "000-therugbynet.md",
				"ext": "md",
				"name": "000-therugbynet",
				"extname": ".md",
				"basename": "000-therugbynet.md",
				"dirname": "projects",
				"stem": "000-therugbynet",
				"path": "projects/000-therugbynet.md"
			},
			"requirePath": "projects/000-therugbynet.md",
			"path": "/projects/000-therugbynet/",
			"data": {
				"title": "The Rugby Net",
				"tagline": "Data-Driven Sports Media",
				"type": "Sports Media",
				"platform": "Web, Mobile Web, SaaS",
				"status": "released",
				"roles": "Developer, UI/UX Designer, Project Manager",
				"header_image_small": "url(./assets/projects/TRN-header.png)",
				"header_image_big": "url(./assets/projects/TRN-header.jpg)",
				"header_background_color": "#000300",
				"header_background_size": "cover"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projects",
				"base": "005-rating-engine.md",
				"ext": "md",
				"name": "005-rating-engine",
				"extname": ".md",
				"basename": "005-rating-engine.md",
				"dirname": "projects",
				"stem": "005-rating-engine",
				"path": "projects/005-rating-engine.md"
			},
			"requirePath": "projects/005-rating-engine.md",
			"path": "/projects/005-rating-engine/",
			"data": {
				"title": "Player Rating Engine",
				"tagline": "Cloud-based workflow for large-scale resilient data processing",
				"type": "Closedsource",
				"platform": "Microservices",
				"status": "released",
				"technologies": [
					"Java",
					"Google App Engine, Datastore, Task Queues, Memcached, Logging",
					"Mapreduce/Pipeline API",
					"Google Cloud Endpoints",
					"NodeJS/Express",
					"ES6",
					"PhantomJS",
					"Winston",
					"Docker/Google Compute Engine"
				],
				"header_image_small": "url(./assets/projects/banner-lg.png)",
				"header_image_big": "url(./assets/projects/banner-lg.png)",
				"header_background_color": "#23201C",
				"header_background_size": "cover"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projects",
				"base": "020-d3-visualisation.md",
				"ext": "md",
				"name": "020-d3-visualisation",
				"extname": ".md",
				"basename": "020-d3-visualisation.md",
				"dirname": "projects",
				"stem": "020-d3-visualisation",
				"path": "projects/020-d3-visualisation.md"
			},
			"requirePath": "projects/020-d3-visualisation.md",
			"path": "/projects/020-d3-visualisation/",
			"data": {
				"title": "Data Visualization",
				"tagline": "Using D3.js to win friends and influence people",
				"type": "Closedsource",
				"platform": "Web",
				"status": "released",
				"technologies": [
					"D3.js",
					"Google Cloud Endpoints"
				],
				"header_image_small": "url(./assets/projects/graph.png)",
				"header_image_big": "url(./assets/projects/graph.png)",
				"header_background_color": "#222222",
				"header_background_size": "cover"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projects",
				"base": "030-rugby-socialmedia.md",
				"ext": "md",
				"name": "030-rugby-socialmedia",
				"extname": ".md",
				"basename": "030-rugby-socialmedia.md",
				"dirname": "projects",
				"stem": "030-rugby-socialmedia",
				"path": "projects/030-rugby-socialmedia.md"
			},
			"requirePath": "projects/030-rugby-socialmedia.md",
			"path": "/projects/030-rugby-socialmedia/",
			"data": {
				"title": "Rugby Social Media",
				"tagline": "In which our hero plays with all the toys",
				"type": "Opensource",
				"platform": "Web, Mobile Web",
				"status": "released",
				"technologies": [
					"React",
					"Redux",
					"GraphQL",
					"MongoDB",
					"Meteor",
					"Digital Cloud hosting"
				],
				"header_image_small": "url(./assets/projects/ReactLogo.png)",
				"header_image_big": "url(./assets/projects/ReactLogo.png)",
				"header_background_color": "#23201C",
				"header_background_size": "contain"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "projects",
				"base": "040-hangboard.md",
				"ext": "md",
				"name": "040-hangboard",
				"extname": ".md",
				"basename": "040-hangboard.md",
				"dirname": "projects",
				"stem": "040-hangboard",
				"path": "projects/040-hangboard.md"
			},
			"requirePath": "projects/040-hangboard.md",
			"path": "/projects/040-hangboard/",
			"data": {
				"title": "Mobile Development",
				"tagline": "Getting a cool react-native app in the app stores",
				"type": "Opensource",
				"platform": "Mobile",
				"status": "released",
				"technologies": [
					"React Native",
					"Redux"
				],
				"header_image_small": "url(./assets/projects/playstore-icon-feature.png)",
				"header_image_big": "url(./assets/projects/playstore-icon-feature.png)",
				"header_background_color": "#23201C",
				"header_background_size": "contain"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 384
// module chunks = 0